export const useCases = [
  {
    id: "new-product-launch",
    title: "New product launch",
    problem:
      "A launch needs consistent claims, visuals, and format variants before the first spend.",
    approach:
      "Load product facts and brand constraints, create launch angles, then produce brief-linked copy and visual variants for review.",
    outcomes: ["Launch brief", "Claim-safe creative candidates", "Reviewable asset versions"],
    status: "Available",
  },
  {
    id: "creative-fatigue",
    title: "Creative fatigue recovery",
    problem:
      "A known winner stops performing, but the reason is buried in prior decisions and assets.",
    approach:
      "Review the winner, its brief, and recent results; generate controlled variations that change one hypothesis at a time.",
    outcomes: ["Variation brief", "Single-variable tests", "Preserved winner context"],
    status: "Available",
  },
  {
    id: "competitor-testing",
    title: "Competitor-informed testing",
    problem:
      "Teams see market patterns but cannot separate useful patterns from noise or copied tactics.",
    approach:
      "Organize authorized market observations, compare them with brand facts, and convert relevant gaps into test hypotheses.",
    outcomes: ["Pattern summary", "Creative gap", "Testable hypothesis"],
    status: "Available",
  },
  {
    id: "localization",
    title: "Multi-market creative localization",
    problem:
      "Translation alone misses offer, claim, format, and visual expectations in another market.",
    approach:
      "Keep the approved concept stable while adapting language, proof, layout, and channel format for local review.",
    outcomes: ["Local brief", "Market constraints", "Comparable versions"],
    status: "Available",
  },
  {
    id: "agency-onboarding",
    title: "Agency client onboarding",
    problem: "New client work starts with scattered assets and unwritten brand decisions.",
    approach:
      "Create a scoped workspace, capture client facts and constraints, then make the first brief and asset set reviewable.",
    outcomes: ["Client workspace", "Brand context", "First reviewable mission"],
    status: "Available",
  },
  {
    id: "brand-safe-production",
    title: "Brand-safe asset production",
    problem:
      "Generation is useful only if claims, compliance constraints, and approvals remain visible.",
    approach:
      "Attach brand rules to production, review outputs against the brief, and keep approval linked to the exact version.",
    outcomes: ["Constraint check", "Approval record", "Traceable version"],
    status: "Available",
  },
];
